import React from "react";
import MainLayoutWithoutFooter from "../components/MainLayoutWithoutFooter";
import FailedPrintsPanel from "../components/failedprints/FailedPrintsPanel";
import "../styles/hardwarePage.css";

const FailedPrintsPage = () => (
  <MainLayoutWithoutFooter>
    <div className="pageContent reservationsPage pb-2">
      <div className="container">
        <FailedPrintsPanel />
      </div>
    </div>
  </MainLayoutWithoutFooter>
);

export default FailedPrintsPage;
